// 🔥 ERROR HANDLER UTILITY

export const ERROR_MESSAGES = {
  // Auth Errors
  "auth/user-not-found": "User account not found",
  "auth/wrong-password": "Incorrect password",
  "auth/invalid-credential": "Invalid email or password",
  "auth/email-already-in-use": "Email already registered",
  "auth/weak-password": "Password too weak (min 6 characters)",
  "auth/invalid-email": "Invalid email format",
  "auth/too-many-requests": "Too many attempts. Try again later",
  "auth/network-request-failed": "Network error. Check your connection",
  
  // Database Errors
  "permission-denied": "Permission denied. Admin access required",
  "not-found": "Document not found in database",
  "already-exists": "Item already exists",
  "failed-precondition": "Operation failed. Precondition check failed",
  "unauthenticated": "Please log in first",
  
  // Storage Errors
  "storage/object-not-found": "File not found",
  "storage/bucket-not-found": "Storage bucket error",
  "storage/project-not-set": "Storage not configured",
  "storage/quota-exceeded": "Storage quota exceeded",
  
  // Network Errors
  NETWORK_ERROR: "Network connection error. Please check your internet",
  TIMEOUT_ERROR: "Request timeout. Please try again",
  
  // Generic
  UNKNOWN_ERROR: "Something went wrong. Please try again",
};

export const getErrorMessage = (error) => {
  if (!error) return ERROR_MESSAGES.UNKNOWN_ERROR;
  
  // Firebase error code
  if (error.code) {
    return ERROR_MESSAGES[error.code] || error.message || ERROR_MESSAGES.UNKNOWN_ERROR;
  }
  
  // Error message
  if (typeof error === "string") {
    return ERROR_MESSAGES[error] || error;
  }
  
  // Error object with message
  if (error.message) {
    return ERROR_MESSAGES[error.message] || error.message;
  }
  
  return ERROR_MESSAGES.UNKNOWN_ERROR;
};

export const logError = (context, error) => {
  console.error(`❌ [${context}]`, {
    code: error?.code,
    message: error?.message,
    stack: error?.stack,
    full: error
  });
};

export const logWarning = (context, message) => {
  console.warn(`⚠️ [${context}]`, message);
};

export const logSuccess = (context, message) => {
  console.log(`✅ [${context}]`, message);
};

export const logInfo = (context, message) => {
  console.log(`ℹ️ [${context}]`, message);
};

// Retry mechanism
export const retryAsync = async (fn, maxRetries = 3, delay = 1000) => {
  let lastError;
  
  for (let i = 0; i < maxRetries; i++) {
    try {
      return await fn();
    } catch (error) {
      lastError = error;
      logWarning(`Retry attempt ${i + 1}/${maxRetries}`, getErrorMessage(error));
      
      if (i < maxRetries - 1) {
        await new Promise(resolve => setTimeout(resolve, delay));
      }
    }
  }
  
  throw lastError;
};
